import {
	faClockRotateLeft as fasClockRotateLeft,
	faPersonDress as fasPersonDress,
	faUser as fasUser,
} from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import dayjs from "dayjs";
import type { FormApi } from "final-form";
import compact from "lodash/compact";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";
import type { AbstractStepProps } from "@/component/assets/AbstractLeadForm/Steps/AbstractStep";
import { AbstractStep } from "@/component/assets/AbstractLeadForm/Steps/AbstractStep";
import type { ProgressButtonState } from "@/shared/ui";
import { FormDate, FormInput, ProgressButton } from "@/shared/ui";

interface StepFields {
	birthName: string;
	birthDate: string;
	motherName: string;
}

interface Props extends AbstractStepProps {
	fullName: string;
	submitState: ProgressButtonState;
}

export class ExtraData extends AbstractStep<StepFields, Props> {
	protected initValues(): StepFields {
		return { birthName: this.props.fullName, birthDate: undefined, motherName: undefined };
	}

	protected renderContent(_values: StepFields, _form: FormApi<StepFields>): ReactNode {
		const { submitState } = this.props;

		return (
			<>
				<Card.Header>
					<Card.Title className="retail-text text-center">
						<FontAwesomeIcon icon={fasClockRotateLeft} className="mr-2" />
						<span className="header-main">GYORSÍTSD AZ ÜGYINTÉZÉST!</span>
						<br />
						<span className="header-sub font-weig">
							Az alábbi adatok megadásával
							<br /> <strong>felére csökkentheted</strong> a számlanyitási időt
						</span>
					</Card.Title>
				</Card.Header>
				<Card.Body>
					<FormInput
						label="Születési név"
						name="birthName"
						prepend={<FontAwesomeIcon icon={fasUser} />}
						validate={this.validFullName}
					/>
					<FormDate
						label="Születési idő"
						name="birthDate"
						autoComplete="bday"
						validate={this.validBirthDate}
					/>
					<FormInput
						label="Anyja leánykori neve"
						name="motherName"
						prepend={<FontAwesomeIcon icon={fasPersonDress} />}
						validate={this.validFullName}
					/>
				</Card.Body>
				<Card.Footer className="text-center">
					<ProgressButton variant="gold" type="submit" size="lg" state={submitState}>
						Tovább
					</ProgressButton>
				</Card.Footer>
			</>
		);
	}

	protected getClassName(): string {
		return compact([super.getClassName(), "bg-success"]).join(" ");
	}

	private validFullName(fullName: string): string {
		if (typeof fullName !== "string" || fullName.length < 1) {
			return "A név megadása kötelező!";
		}

		if (fullName.length < 2) {
			return "A megadott név túl rövid.";
		}

		if (!fullName.includes(" ")) {
			return "A teljes nevet meg kell adni!";
		}
	}

	private validBirthDate(birthDate: string): string {
		if (!birthDate) {
			return "A születési dátum megadása kötelező!";
		}

		const date = dayjs(birthDate, "YYYY-MM-DD").add(18, "year");

		if (date.isAfter(dayjs())) {
			return "Az ügyfélnek nagykorúnak kell lennie!";
		}

		const age = dayjs().diff(date, "year");

		if (age > 100) {
			return "A hiteligénylő személy nem lehet 100 éven felüli!";
		}
	}

	protected getComponentName(): string {
		return "ExtraData";
	}
}
